import { createReducer } from '@ngrx/store';

import { MowingMonitorState } from '../models/mowing-monitor.model';

export const initialState: MowingMonitorState = {
  companySettings: null,
  adviceSettings: null,
  monitor: null,
};

export const mowingMonitorReducer = createReducer<MowingMonitorState>(initialState);
